import axios from '@_system/axios/axios.js'
export default {
	path: '/reconciliationbankflow',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getFinBill(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getFinBill', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	copyBycode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/copyBycode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getSummary(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getSummary', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getReceiptInfo(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getReceiptInfo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	reflashDownloadNo(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/reflashDownloadNo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	sendReceipt(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/sendReceipt', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	sendjindie(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/sendjindie', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},		
	sendwln(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/sendwln', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},		
	addcustomflow(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/addcustomflow', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	custommark(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/custommark', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	supplyflow(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/supplyflow', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
		
	flow2collection(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/flow2collection', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	collectionbackwash(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/collectionbackwash', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	getbankacc(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getbankacc', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	checkerror(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/checkerror', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updateignore(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updateignore', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/report.reconciliation.reconciliationbankflow', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
